import { render, staticRenderFns } from "./CustomIsLargess.vue?vue&type=template&id=242557c8&scoped=true"
import script from "./CustomIsLargess.vue?vue&type=script&lang=js"
export * from "./CustomIsLargess.vue?vue&type=script&lang=js"
import style0 from "./CustomIsLargess.vue?vue&type=style&index=0&id=242557c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242557c8",
  null
  
)

export default component.exports